// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slide-in-move{transition:opacity .15s linear,transform .15s ease-in-out}.slide-in-leave-active{transition:opacity .15s linear,transform .15s cubic-bezier(.5,0,.7,.4)}.slide-in-enter-active{transition:opacity .15s linear,transform .15s cubic-bezier(.2,.5,.1,1);transition-delay:.25s}.slide-in-enter,.slide-in-leave-to{opacity:0}", ""]);
// Exports
module.exports = exports;
